// Shimmer.jsx
export const Shimmer = ({ lines = 5, className = "" }) => {
  return (
    <div className={`shimmer-wrapper ${className}`}>
      {[...Array(lines)].map((_, idx) => (
        <div key={idx} className="shimmer-line"></div>
      ))}
    </div>
  );
};
